
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleCallClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'clic_pulsante_chiamata'
      });
    }
  };

  return (
    <nav className="w-full bg-white border-b border-gray-200 fixed top-0 left-0 right-0 z-50 hidden lg:block">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <img 
            src="https://static.readdy.ai/image/4355c335405d5d43b86c7110ab8a5984/3a445f8126566575908e72be27b6b438.png" 
            alt="Logo" 
            className="h-20 w-auto"
          />
          <div className="flex items-center gap-3">
            <button 
              onClick={scrollToPricing}
              className="whitespace-nowrap px-6 py-3 text-sm font-medium bg-white text-black border-2 border-black hover:bg-black hover:text-white transition-all duration-300 cursor-pointer"
            >
              Prezzo Landing
            </button>
            <button
              onClick={handleCallClick}
              data-cal-link="andrea-disanto-0kedbr/30min"
              data-cal-namespace="30min"
              data-cal-config='{"layout":"month_view"}'
              className="whitespace-nowrap px-6 py-3 text-sm font-medium bg-black text-white border-2 border-black hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
            >
              Prenota una Call Gratuita
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
